<template>
  <div v-if="fetched" class="p-0 m-0 table-container">
    <table-header
      :title="`Sms${
        numberOfSentSmses
          ? ` - liczba wysłanych smsów w tym miesiącu: ${numberOfSentSmses}`
          : ``
      }`"
      :withPagination="true"
      :dispatchAction="'fetchSmsListForAllUser'"
      :onPage="this.smsList ? this.smsList.on_page : 20"
      :pageNumber="this.smsList ? this.smsList.page_number : 1"
      :total="this.smsList.total"
    ></table-header>

    <button
      v-if="this.smsList && this.smsList.list && this.smsList.list.length > 0"
      type="button"
      class="addNewButton"
      data-toggle="modal"
      data-target="#addNewSms"
    >
      Wyślij SMS
    </button>
    <button
      v-if="this.smsList && this.smsList.list && this.smsList.list.length > 0"
      type="button"
      class="addNewButton"
      data-toggle="modal"
      data-target="#addNewGroupSms"
    >
      Wyślij SMS grupowego
    </button>
    <table
      class="table table-striped"
      v-if="this.smsList && this.smsList.list && this.smsList.list.length > 0"
    >
      <thead>
        <tr style="width: 100%">
          <th scope="col">ID wiadomości</th>
          <th scope="col">Data wysłania</th>
          <th scope="col">Login admina</th>
          <th scope="col">Tel. odbiorcy</th>
          <th scope="col">Wiadomość</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sms in smsList.list" :key="sms.id" style="width: 100%">
          <td>{{ sms.id }}</td>
          <td>
            {{
              sms.creationDate && formattedDate
                ? formattedDate(sms.creationDate)
                : ""
            }}
          </td>
          <td>{{ sms.sender.phone }}</td>
          <td v-if="sms.receiver">{{ sms.receiver.phone }}</td>
          <td v-else>
            <p v-if="sms.phone_number">{{ sms.phone_number }}</p>
            <button
              v-if="sms.phone_numbers && sms.phone_numbers.length > 0"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#phoneNumbers"
              @click="setGroupPhoneNumbersToShow(sms.phone_numbers)"
            >
              Lista numerów
            </button>
          </td>
          <td>{{ sms.message }}</td>
          <div
            class="modal fade"
            id="phoneNumbers"
            tabindex="-1"
            role="dialog"
            aria-labelledby="phoneNumbers"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="phoneNumbers">Lista numerów</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <span
                    v-for="number in groupSmses"
                    :key="number"
                    style="margin-right: 1rem"
                    >{{ number }}
                  </span>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>

    <div
      class="modal fade"
      id="addNewSms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewSms"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="sms-title">
              <h5 class="modal-title" id="addNewSms">Nowy sms</h5>
              <div class="d-flex">
                <span class="mt-2 mr-2">Prezentowany numer:</span>
                <select v-model="selectedSenderPhoneNumber">
                  <option value="727207020" selected>727207020</option>
                  <option value="606991111">606991111</option>
                  <option value="602743744">602743744</option>
                  <option value="SENIORAPP">SENIORAPP</option>
                  <!-- MARKETING sender temporarily disabled; restore by uncommenting -->
                  <!-- <option value="MARKETING">MARKETING</option> -->
                </select>
              </div>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="addNewSmsForm" @submit.prevent="sendSms()">
              <div class="input-container">
                <input
                  v-model="phoneNumber"
                  id="title"
                  class="form-control"
                  type="number"
                  required
                  minlength="9"
                  maxlength="9"
                  placeholder="Numer telefonu"
                />
              </div>
              <div class="input-container">
                <textarea
                  v-model="message"
                  id="message"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                  maxlength="1024"
                  placeholder="Wiadomość..."
                />
              </div>

              <button
                class="buttonm btn btn-outline-dark addNewSmsButton"
                type="submit"
              >
                Wyślij
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="addNewGroupSms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewSms"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="sms-title">
              <h5 class="modal-title" id="addNewSms">Nowy sms grupowy</h5>
              <div class="d-flex">
                <span class="mt-2 mr-2">Prezentowany numer:</span>
                <select v-model="selectedSenderPhoneNumberForGroupSms">
                  <option value="727207020" selected>727207020</option>
                  <option value="606991111">606991111</option>
                  <option value="602743744">602743744</option>
                  <option value="SENIORAPP">SENIORAPP</option>
                  <!-- MARKETING sender temporarily disabled; restore by uncommenting -->
                  <!-- <option value="MARKETING">MARKETING</option> -->
                </select>
              </div>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="addNewSmsForm" @submit.prevent="sendGroupSms()">
              <div class="selectUsersContainer">
                <div class="sendGroupSmsModal selectUsersContainerDiv">
                  <div>
                    <div>
                      <input
                        type="checkbox"
                        id="userGroupCheckbox"
                        v-model="toUserGroup"
                      />
                      <label for="userGroupCheckbox"
                        >Wybierz grupę użytkowników</label
                      >
                    </div>
                  </div>

                  <div v-if="toUserGroup">
                    <div class="row">
                      <div class="col">
                        <label for="">Kto?</label>
                        <select v-model="pickedOption">
                          <option
                            class="option"
                            :value="option.name"
                            v-for="option in options"
                            :key="option.id"
                          >
                            {{
                              option.name === "selected_phone_numbers"
                                ? option.displayName
                                : option.displayName +
                                  " (" +
                                  getCounter(option.name) +
                                  ")"
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="col">
                        <label for="">Partnerzy</label>
                        <select
                          @change="newPartnersPicked"
                          v-model="pickedOptionPartners"
                        >
                          <option class="option" :value="'none'">Brak</option>
                          <option
                            class="option"
                            :value="option.id"
                            v-for="option in partnersArray"
                            :key="option.id"
                          >
                            {{ option.name + " (" + option.amount + ")" }}
                          </option>
                        </select>
                      </div>
                      <div class="row checkbox-row">
                        <input
                          id="check"
                          v-model="marketingAgreement"
                          type="checkbox"
                        />
                        <label for="check"
                          >Wyślij również do osób bez zgód marketingowych</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="selectUsersContainerDiv">
                  <div>
                    <div>
                      <input
                        type="checkbox"
                        id="userSelectCheckbox"
                        v-model="userSelect"
                      />
                      <label for="userSelectCheckbox"
                        >Wybierz użytkowników z listy</label
                      >
                    </div>
                  </div>
                  <div v-if="userSelect">
                    <form @submit.prevent="handleSearchUsers()">
                      <div class="inner-addon left-addon">
                        <svg
                          class="searchIcon"
                          width="40"
                          height="35"
                          viewBox="0 0 30 29"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g opacity="0.3" clip-path="url(#clip0)">
                            <path
                              d="M26.8421 28.9995C26.5263 28.9995 26.2105 28.9995 25.8947 28.9995C25.5947 28.8 25.2474 28.6619 24.9947 28.4164C23.2579 26.7593 21.5368 25.0868 19.8158 23.4143C19.3263 22.954 19.0737 22.3249 19.3263 21.7418C19.6105 21.0974 19.3579 20.7598 18.9158 20.3915C18.6947 20.2074 18.4737 20.0233 18.3 19.7931C17.9211 19.3175 17.6053 19.3175 17.0684 19.655C11.8421 22.9693 4.76842 21.3582 1.56316 16.1566C0.742105 14.837 0.363158 13.3794 0 11.9064C0 11.1392 0 10.3873 0 9.62011C0.0473684 9.42064 0.126316 9.23652 0.157895 9.03704C0.852632 4.63334 4.32632 1.15027 8.92105 0.214293C13.2789 -0.675654 18.0316 1.24234 20.3842 4.95556C22.8316 8.83757 22.7368 12.7503 20.2895 16.6169C20.1474 16.8318 19.8316 17.0312 20.1474 17.3381C20.6368 17.8138 21.1105 18.2741 21.6 18.7497C21.7737 18.9185 21.9158 18.8418 22.1053 18.7804C23.0368 18.4122 23.7632 18.6884 24.4421 19.3482C25.9263 20.8212 27.4421 22.2788 28.9579 23.7212C29.3684 24.1201 29.7316 24.5344 30 25.0407C30 25.3476 30 25.6545 30 25.9614C29.1947 27.2042 28.1368 28.2169 26.8421 28.9995ZM11.0368 18.3815C15.4263 18.3968 18.9632 15.0058 18.9789 10.7556C18.9947 6.5053 15.4895 3.06826 11.1158 3.05292C6.69474 3.03757 3.15789 6.39789 3.12632 10.6482C3.09474 14.9445 6.6 18.3661 11.0368 18.3815Z"
                              fill="#090741"
                            />
                            <path
                              d="M15.3001 8.13255C15.2528 8.6389 15.0159 9.06853 14.4949 9.31404C13.9738 9.55954 13.437 9.55954 13.0107 9.20663C11.7001 8.10187 10.4528 8.13255 9.14223 9.22197C8.5896 9.68229 7.78434 9.52885 7.29486 9.0225C6.82118 8.5315 6.7896 7.7643 7.23171 7.21192C8.92118 5.06377 13.358 5.07911 15.0001 7.24261C15.1896 7.50345 15.3001 7.77964 15.3001 8.13255Z"
                              fill="#090741"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="30" height="29" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>

                        <input
                          type="text"
                          placeholder="Szukaj..."
                          style="border-radius: 10px"
                          class="form-control searchBlock"
                          v-model="searchParam"
                        />
                      </div>
                    </form>

                    <pagination-inline
                      v-if="fetched && users && users.pagination"
                      :dispatchAction="`getAllProfiles`"
                      :onPage="20"
                      :pageNumber="users.pagination.page_number"
                      :total="users.pagination.total"
                      :searchParam="searchParam"
                    ></pagination-inline>

                    <table class="table table-sm" v-if="users && users.data">
                      <thead>
                        <tr style="width: 100%">
                          <th scope="col">Imię</th>
                          <th scope="col">Nazwisko</th>
                          <th scope="col">Telefon</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="data in users.data"
                          :key="data.id"
                          @click="addOrRemoveFromAddedNumbers(data.phone)"
                          :style="
                            phoneNumbers.includes(data.phone)
                              ? 'background: #F6C689;'
                              : ''
                          "
                        >
                          <td>{{ data.first_name }}</td>
                          <td>{{ data.last_name }}</td>
                          <td>{{ data.phone }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div v-if="pickedOption === 'selected_phone_numbers'">
                <div>
                  <div class="selectUsersContainerDiv">
                    <form @submit.prevent="addOwnNumber">
                      <div>
                        <input id="addNumbersCheckbox" v-model="ownNumber" />
                        <button type="submit" class="btn btn-outline-dark">
                          Dodaj numer
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="addedNumbers">
                <div v-for="partner in pickedPartners" :key="partner.id">
                  {{ partner.name }}
                  <i
                    class="fas fa-times removeNumberIcon"
                    @click="deletePartner(partner)"
                  ></i>
                </div>
              </div>
              <div
                v-if="pickedOption === 'selected_phone_numbers' || userSelect"
                class="addedNumbers"
              >
                <div v-for="number in this.phoneNumbers" :key="number">
                  {{ number }}
                  <i
                    class="fas fa-times removeNumberIcon"
                    @click="deletePhoneNumber(number)"
                  ></i>
                </div>
              </div>
              <div class="input-container">
                <textarea
                  v-model="message"
                  id="message"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                  maxlength="1024"
                  placeholder="Wiadomość..."
                />
              </div>

              <button
                class="buttonm btn btn-outline-dark addNewSmsButton"
                type="submit"
              >
                Wyślij
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
              id="closeGroupSmsModal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
import axios from "../axios";
import PaginationInline from "../components/PaginationInline.vue";
import TableHeader from "../components/TableHeader";
import { options } from "./../utils/options";

export default {
  name: "SmsList",
  components: { TableHeader, PaginationInline },

  data() {
    return {
      searchParam: "",
      toUserGroup: false,
      userSelect: false,
      phoneNumbers: [],
      addNumbers: false,
      phoneNumber: "",
      pageNumber: 1,
      message: "",
      seniors: false,
      employees: false,
      employees_accepted: false,
      employees_not_finished_payment: false,
      all: false,
      selectedGroup: null,
      ownNumber: null,
      groupSmses: [],
      pickedOption: "all",
      pickedPartners: [],
      pickedOptionPartners: "none",
      marketingAgreement: false,
      options,
      formattedDate: null,
      fetched: false,
      selectedSenderPhoneNumber: "727207020",
      selectedSenderPhoneNumberForGroupSms: "727207020",
    };
  },
  async mounted() {
    await this.$store.dispatch("getAllProfiles", {
      on_page: 20,
      page_number: 1,
    });
    this.fetched = true;
  },
  created() {
    this.$store.dispatch("fetchSmsListForAllUser", {
      page_number: 1,
      on_page: 20,
    });

    this.$store.dispatch("fetchUserGroupsCounter", {});

    this.formattedDate = shared.formattedDateAsNumbers;
    this.$store.dispatch("fetchNumberOfSentSmsesInCurrentMonth");
  },

  destroyed() {
    this.$store.dispatch("setNullToSmsList");
  },
  methods: {
    setGroupPhoneNumbersToShow(smses) {
      this.groupSmses = smses;
    },
    sendSms() {
      axios
        .get(`api/user/${this.phoneNumber}/exist`)
        .then(() => {
          axios
            .post(`api/smsFromAdmin/${this.phoneNumber}`, {
              message: this.message,
              sender_phone_number: this.selectedSenderPhoneNumber,
            })
            .then(() => {
              this.$notify({
                group: "success",
                text: "Pomyślnie wysłano wiadomość",
              });
              this.$store.dispatch("fetchSmsListForAllUser", {
                page_number: this.smsList.page_number,
                on_page: this.smsList.on_page,
              });
              this.$store.dispatch("fetchNumberOfSentSmsesInCurrentMonth");
              (this.phoneNumber = ""), (this.message = "");
            })
            .catch((err) => {
              console.log(err.response.data.error);
              if (err.response.data.error === "not_found_user") {
                this.$notify({
                  group: "error",
                  text: "Nie istnieje użytkownik o podanym numerze",
                });
              } else {
                this.$notify({
                  group: "error",
                  text: "Nie udało się wysłać wiadomości",
                });
              }
            });
        })
        .catch(() => {
          const confirm = prompt(
            `Użytkownik o podanym numerze telefonu nie istnieje. Jeśli chcesz wysłać wiadomość na ten numer wpisz  'TAK'`
          );
          if (confirm === "TAK") {
            axios
              .post(`api/smsFromAdmin/${this.phoneNumber}`, {
                message: this.message,
              })
              .then(() => {
                this.$notify({
                  group: "success",
                  text: "Pomyślnie wysłano wiadomość",
                });
                this.$store.dispatch("fetchSmsListForAllUser", {
                  page_number: this.smsList.page_number,
                  on_page: this.smsList.on_page,
                });
                (this.phoneNumber = ""), (this.message = "");
              })
              .catch((err) => {
                console.log(err.response.data.error);
                if (err.response.data.error === "not_found_user") {
                  this.$notify({
                    group: "error",
                    text: "Nie istnieje użytkownik o podanym numerze",
                  });
                } else {
                  this.$notify({
                    group: "error",
                    text: "Nie udało się wysłać wiadomości",
                  });
                }
              });
          }
        });
    },
    deletePhoneNumber(number) {
      const index = this.phoneNumbers.indexOf(number);
      if (index !== -1) {
        this.phoneNumbers.splice(index, 1);
      }
    },
    deletePartner(partner) {
      const index = this.pickedPartners.indexOf(partner);
      if (index !== -1) {
        this.pickedPartners.splice(index, 1);
      }
    },
    addOwnNumber() {
      if (this.ownNumber.includes(" ")) {
        this.ownNumber.split(" ").forEach((number) => {
          if (number && number !== "" && !this.phoneNumbers.includes(number)) {
            this.phoneNumbers.push(number);
          }
        });
        this.ownNumber = null;
      } else {
        if (
          this.ownNumber &&
          this.ownNumber !== "" &&
          !this.phoneNumbers.includes(this.ownNumber)
        ) {
          this.phoneNumbers.push(this.ownNumber);
          this.ownNumber = null;
        } else {
          this.ownNumber = null;
        }
      }
    },
    addOrRemoveFromAddedNumbers(phoneNumber) {
      if (!this.phoneNumbers.includes(phoneNumber)) {
        this.phoneNumbers.push(phoneNumber);
      } else {
        const index = this.phoneNumbers.indexOf(phoneNumber);
        if (index !== -1) {
          this.phoneNumbers.splice(index, 1);
        }
      }
    },
    newPartnersPicked() {
      if (this.pickedOptionPartners === "none") {
        this.pickedPartners = [];
        return;
      }
      this.partnersArray.forEach((partner) => {
        if (partner.id === this.pickedOptionPartners) {
          this.pickedPartners.push({ name: partner.name, id: partner.id });
        }
      });
    },
    handleSearchUsers() {
      this.$store.dispatch("getAllProfiles", {
        on_page: this.users.pagination.on_page,
        page_number: 1,
        search_param: this.searchParam,
      });
    },
    setButton(type) {
      if (type === "seniors") {
        this.seniors = true;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.selectedGroup = "seniors";
      }
      if (type === "employees") {
        this.seniors = false;
        this.employees = true;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.selectedGroup = "employees";
      }
      if (type === "employees_accepted") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = true;
        this.employees_not_finished_payment = false;
        this.selectedGroup = "employees_accepted";
      }
      if (type === "employees_not_finished_payment") {
        this.seniors = false;
        this.employees = false;
        this.all = false;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = true;
        this.selectedGroup = "employees_not_finished_payment";
      }
      if (type === "all") {
        this.seniors = false;
        this.employees = false;
        this.all = true;
        this.singleUser = false;
        this.employees_accepted = false;
        this.employees_not_finished_payment = false;
        this.selectedGroup = "all";
      }
    },

    async sendGroupSms() {
      let partnersIDs = [];
      this.pickedPartners.map((partner) => {
        partnersIDs.push(partner.id);
      });
      this.pickedPartners = partnersIDs;
      const obj = {
        sender_phone_number: this.selectedSenderPhoneNumberForGroupSms,
        message: this.message,
        phone_numbers:
          this.pickedOption === "selected_phone_numbers" || this.userSelect
            ? this.phoneNumbers
            : [],
        group: this.toUserGroup ? this.pickedOption : null,
        partners_ids: this.pickedPartners,
        not_required_marketing_agreement: this.marketingAgreement,
      };
      await axios
        .post(`api/smsFromAdmin/group`, obj)
        .then(() => {
          this.$notify({
            group: "success",
            text: "Pomyślnie wysłano smsa do wybranych użytkowników",
          });
          (this.searchParam = ""), (this.selectedGroup = null);
          this.seniors = false;
          this.employees = false;
          this.all = false;
          this.singleUser = false;
          this.employees_accepted = false;
          this.employees_not_finished_payment = false;
          this.phoneNumbers = [];
          (this.message = ""), (this.toUserGroup = false);
          this.userSelect = false;

          setTimeout(() => {
            this.$store.dispatch("fetchSmsListForAllUser", {
              page_number: this.smsList.page_number,
              on_page: this.smsList.on_page,
            });
            this.$store.dispatch("fetchNumberOfSentSmsesInCurrentMonth");
          }, 2000);
          document.getElementById("closeGroupSmsModal").click();
        })
        .catch((err) => {
          console.log(err);
        });
      this.pickedPartners = [];
    },
    getCounter(name) {
      if (this.userGroupsCounter !== null) {
        if (name === "all") return this.userGroupsCounter.all;
        if (name === "seniors") return this.userGroupsCounter.seniors;
        if (name === "employees") return this.userGroupsCounter.employees;
        if (name === "employees_accepted")
          return this.userGroupsCounter.employeesAccepted;
        if (name === "employees_not_finished_payment")
          return this.userGroupsCounter.employeesNotFinishedPayment;
      }
    },
  },

  computed: {
    numberOfSentSmses() {
      return this.$store.getters.getNumberOfSentSmsesInCurrentMonth;
    },
    smsList() {
      return this.$store.getters.getSmsList;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    userGroupsCounter() {
      return this.$store.getters.getUserGroupsCounter;
    },
    partnersArray() {
      return this.$store.getters.getPartners;
    },
  },
};
</script>

<style scoped>
.sms-title {
  display: flex;
  align-items: center;
  gap: 4rem;
}
.col {
  display: flex;
  flex-direction: column;
  width: 300px;
}
.row {
  display: flex;
  flex-direction: column;
}

select {
  padding: 5px;
  background: #fff;
  border: none;
  border-radius: 3px;
  color: #090741;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.option {
  background: #fff;
  color: #090741;
}
.addNewSmsButton {
  width: 100%;
  text-align: center;
}
.addNewSmsForm label {
  margin-left: 5px;
}
.selectUsersContainer {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.selectUsersContainerDiv {
  width: 50%;
}
.searchUserPanel {
  display: flex;
  align-items: center;
  width: 100%;
}
.inner-addon {
  position: relative;
}

/* style icon */
.inner-addon .searchIcon {
  position: absolute;
  padding: 10px;
  bottom: 2px;
  pointer-events: none;
}

/* add padding  */
.left-addon input {
  padding-left: 30px;
}
.addNewSmsForm table {
  font-size: 9px;
}
.addNewSmsForm thead {
  height: 20px !important;
}
.addedNumbers {
  display: flex;
  flex-wrap: wrap;
}
.addedNumbers div {
  border: 1px solid rgb(173, 172, 172);
  padding: 5px;
  margin: 3px;
  border-radius: 50px;
  position: relative;
  min-width: 90px;
  padding-right: 20px;
}
.removeNumberIcon {
  cursor: pointer;
  position: absolute;
  right: 6px;
  top: 8px;
}
.checkbox-row label {
  margin-top: 5px;
  margin-left: 5px;
  color: #090741;
  font-size: 11px;
}
.checkbox-row {
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  margin-top: 15px;
}
</style>
